export const PhotoChooseType = {
    Unknow:0,
    Cover:1,
    Video:2,
    Photo:3,
    Editor:4,
    Color_Cover:5,
    Color_Photo:6,
    Color_Editor:7
    
  }

  //服务端传的资源类型ctype 1图片 2视频
  export const SourceType = {
    NoLimited:0,
    Image:1,
    Video:2
  }